/* eslint-disable max-classes-per-file */
import { createAction, props } from '@ngrx/store';

const actionKey = '[Filter config]';

export const setViewType = createAction(`${actionKey} set display view`, props<{ payload: any }>());

export const setViewTypeSuccess = createAction(
  `${actionKey} set display view success`,
  props<{ payload: any }>(),
);

export const setStorageDisplayView = createAction(
  `${actionKey} Set display view from the localStorage`,
);
